import styled from "styled-components";

export const MainContentsSection = styled.section`
  height: 100vh;
  display: flex;
  flex-direction: column;
  gap: 8px;
`;

export const MainContentsListTit = styled.div`
  display: flex;
  padding-left: 4px;
  font-size: 1.6rem;
  align-items: center;
  gap: 6px;
`;

export const MainContentsCount = styled.div`
  display: flex;
  padding: 3px 8px;
  color: ${(props) => props.theme.colors.white};
  font-size: 1.2rem;
  font-weight: 600;
  background: ${(props) => props.theme.colors.tagBg};
  border-radius: 4px;
  align-items: center;
  justify-content: center;
`;

export const MainContentsList = styled.ul`
  display: flex;
  flex-direction: column;
  gap: 10px;
`;
